import { useEffect, useState } from "react";

export default function ShopMap() {
  const API_URL =
    process.env.REACT_APP_API_URL || "https://betking.waresford.com";
  const API_URLx = process.env.REACT_APP_API_URL || "http://localhost:1000";

  const [map, setMap] = useState(null);
  const [userPos, setUserPos] = useState(null);
  const [shops, setShops] = useState([]);
  const [directionsService, setDirectionsService] = useState(null);
  const [directionsRenderer, setDirectionsRenderer] = useState(null);

  useEffect(() => {
    // Load shops from backend
    fetch(`${API_URL}/shops`)
      .then((res) => res.json())
      .then((data) => setShops(data));

    // Get user location
    navigator.geolocation.getCurrentPosition((pos) => {
      const userLocation = {
        lat: pos.coords.latitude,
        lng: pos.coords.longitude,
      };
      setUserPos(userLocation);

      // Initialize map
      const googleMap = new window.google.maps.Map(
        document.getElementById("map"),
        {
          center: userLocation,
          zoom: 13,
        }
      );

      // 🟢 Green marker for YOU
      new window.google.maps.Marker({
        position: userLocation,
        map: googleMap,
        icon: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
        label: "Me",
      });

      setMap(googleMap);
      setDirectionsService(new window.google.maps.DirectionsService());
      setDirectionsRenderer(new window.google.maps.DirectionsRenderer());
    });
  }, []);

  useEffect(() => {
    if (!map || shops.length === 0) return;

    shops.forEach((shop) => {
      // 🔵 Blue marker for shops
      const marker = new window.google.maps.Marker({
        position: { lat: parseFloat(shop.lat), lng: parseFloat(shop.lng) },
        map,
        icon: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
      });

      const infoWindow = new window.google.maps.InfoWindow({
        content: `<strong>${shop.name}</strong><br>${shop.address}`,
      });

      marker.addListener("click", () => {
        infoWindow.open(map, marker);

        // Draw route
        directionsRenderer.setMap(map);

        directionsService.route(
          {
            origin: userPos,
            destination: {
              lat: parseFloat(shop.lat),
              lng: parseFloat(shop.lng),
            },
            travelMode: "DRIVING",
          },
          (result, status) => {
            if (status === "OK") {
              directionsRenderer.setDirections(result);
            }
          }
        );
      });
    });
  }, [map, shops]);

  return (
    <div>
      <h2>Shops Map</h2>
      <div id="map" style={{ width: "100%", height: "500px" }}></div>
    </div>
  );
}
